import { getMockedResponseForOnboardingModuleConfig } from 'bundles/onboarding-common/mocks';
import type { InferredRole, ModularOnboardingEntrypoint } from 'bundles/onboarding-common/types';

export type OnboardingModuleConfigRequest = {
  entrypoint: ModularOnboardingEntrypoint;
  inferredRole?: InferredRole;
};

const useGetOnboardingModuleConfig = (configInput: OnboardingModuleConfigRequest, skip: boolean = false) => {
  // TODO: Remove this once we have the BE call working
  if (skip) {
    return {
      displayModule: false,
      module: null,
    };
  }

  // TODO: Make BE call to get the config
  return getMockedResponseForOnboardingModuleConfig(configInput);
};

export default useGetOnboardingModuleConfig;
